import { Button } from "@backslashbuild/pp-ui";
import React from "react";

export default function ViewDraftErrorsButton({ onClick }) {
  return (
    <Button
      large
      onClick={() => {
        onClick();
      }}
    >
      View Draft Errors
    </Button>
  );
}
